import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={46}
            height={46}
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x={3} y={3} width={40} height={40} rx={20} fill={!props.isHover ? "#F2F4F7" : theme["#B4E3E1"]} />
            <path
                d="M19.666 26.333L23 23m0 0l3.333 3.333M23 23v7.5m6.666-3.548a4.583 4.583 0 00-2.917-8.12.516.516 0 01-.444-.25 6.25 6.25 0 10-9.816 7.58"
                stroke={!props.isHover ? "#475467" : theme["#0D968F"]}
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x={3}
                y={3}
                width={40}
                height={40}
                rx={20}
                stroke={!props.isHover ? "#F9FAFB" : theme["#E7F6F5"]}
                strokeWidth={6}
            />
        </svg>
    )
}
  
  export default SvgComponent